import { Component, OnInit, ViewChild } from '@angular/core';
import { EstadoCuentaClientesService } from '../../services/estado-cuenta-clientes.service';
import { HelpersService } from '../../services/tools/helpers.service';
import { SecurityModalComponent } from '../partials/security-modal/security-modal.component';
import { AutenticacionService } from '../../services/autenticacion.service';
import { ReportesService } from '../../services/reportes.service';

@Component({
    selector: 'app-estado-cuenta-clientes',
    templateUrl: './estado-cuenta-clientes.component.html',
    styleUrls: ['./estado-cuenta-clientes.component.scss']
})
export class EstadoCuentaClientesComponent implements OnInit {

    @ViewChild(SecurityModalComponent) securityModal: SecurityModalComponent;

    //Modo sobre: prendido se ven los ingresos en sobre de la obra
    public securityActived: boolean = false;
    public obras: any = [];
    public obraSeleccionada: any = {};
    public fechaInicial: string;
    public fechaFinal: string;
    //Los honorarios se cotizan como este porcentaje de lo cotizado a los contratistas. Al elegir
    //la obra toma el de su catalogo
    public porcentajeHonorarios: any = 18;
    public reporte: any = null;
    public loading: boolean = false;
    public errores: any = {};

    constructor(
        private estadoCuentaService: EstadoCuentaClientesService,
        private helperService: HelpersService,
        private authService: AutenticacionService,
        private reportesService: ReportesService) { }

    ngOnInit() {
        //El datepicker recibe y devuelve la fecha en formato ISO (aaaa-mm-dd)
        const hoy = new Date();
        //Por default el año en curso, que es como se revisa el estado de cuenta de una obra
        this.fechaInicial = this.aISO(new Date(hoy.getFullYear(), 0, 1));
        this.fechaFinal = this.aISO(hoy);
        //El modo sobre puede venir prendido de otra pantalla
        this.securityActived = !!(this.authService.auth_user && Number(this.authService.auth_user.key) === 1);
        this.cargarObras();
    }

    // === Modo sobre ===

    public canSecurity() {
        return this.reportesService.canSecurity();
    }

    /** Click en el sobre: si esta apagado pide la contraseña, si esta prendido lo apaga. */
    public securityModule() {
        if (!this.securityActived) {
            this.securityModal.open();
            return;
        }

        this.authService.closeKey().subscribe(response => {
            const respuesta = response.json();
            if (respuesta && respuesta.success) {
                this.securityActived = false;
                if (this.authService.auth_user) {
                    this.authService.auth_user.key = 0;
                }
                this.securityModal.push({ 'passwordActivated': false });
                //Se vuelve a generar para que desaparezcan los ingresos en sobre
                if (this.reporte) { this.generar(); }
            }
        });
    }

    public checkSecurityKey(password) {
        this.securityModal.loading = true;
        this.reportesService.activeSecurityModule(password).subscribe(response => {
            const respuesta = response.json();
            this.securityModal.loading = false;
            if (respuesta && respuesta.success === true) {
                this.securityActived = true;
                if (this.authService.auth_user) {
                    this.authService.auth_user.key = 1;
                }
                this.securityModal.push({ 'passwordActivated': true });
                this.securityModal.close();
                //Con el sobre prendido el estado de cuenta ya trae los ingresos en sobre
                if (this.reporte) { this.generar(); }
            }
        }, error => {
            this.securityModal.loading = false;
            this.helperService.httpGlobalError(error, false);
            this.securityModal.lock();
            this.securityActived = false;
            this.securityModal.push({ 'passwordActivated': false });
        });
    }

    private cargarObras() {
        this.estadoCuentaService.getObras().subscribe(response => {
            this.obras = response.json().content;
        }, error => {
            this.helperService.httpGlobalError(error);
        });
    }

    /**
     * Al elegir la obra el rango arranca desde su primer movimiento, porque el estado de
     * cuenta normalmente se pide completo (la obra puede haber empezado años antes).
     */
    public seleccionarObra(obra) {
        this.obraSeleccionada = obra;

        if (obra && obra.fechaPrimerMovimiento) {
            this.fechaInicial = obra.fechaPrimerMovimiento;
        }

        //El porcentaje de honorarios arranca en el que tiene la obra en el catalogo; se puede cambiar
        if (obra && obra.porcentajeHonorarios !== null && obra.porcentajeHonorarios !== undefined && obra.porcentajeHonorarios !== '') {
            this.porcentajeHonorarios = Number(obra.porcentajeHonorarios);
        }
    }

    public generar() {
        this.errores = {};

        if (!this.obraSeleccionada || !this.obraSeleccionada.idObras) {
            this.errores.obra = 'Seleccione una obra';
            return;
        }

        const porcentaje = Number(this.porcentajeHonorarios);
        if (this.porcentajeHonorarios === '' || this.porcentajeHonorarios === null || isNaN(porcentaje) || porcentaje < 0 || porcentaje > 100) {
            this.errores.porcentajeHonorarios = 'Entre 0 y 100';
            return;
        }

        this.loading = true;
        this.reporte = null;

        this.estadoCuentaService.generar(
            this.obraSeleccionada.idObras,
            this.fechaInicial,
            this.fechaFinal,
            porcentaje
        ).subscribe(response => {
            const respuesta = response.json();
            this.reporte = respuesta.content;
            this.loading = false;
        }, error => {
            this.loading = false;
            this.helperService.httpGlobalError(error);
        });
    }

    private aISO(fecha: Date) {
        const mes = ('0' + (fecha.getMonth() + 1)).slice(-2);
        const dia = ('0' + fecha.getDate()).slice(-2);
        return fecha.getFullYear() + '-' + mes + '-' + dia;
    }

    public print() {
        window.print();
    }

    public hayContratistas() {
        return this.reporte && this.reporte.contratistas && this.reporte.contratistas.length > 0;
    }

    public hayIngresosDirectos() {
        return this.reporte && this.reporte.ingresos_directos && this.reporte.ingresos_directos.length > 0;
    }

    public hayIngresosSobre() {
        return this.reporte && this.reporte.ingresos_sobre && this.reporte.ingresos_sobre.length > 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/estado-cuenta-clientes/estado-cuenta-clientes.component.ts